<template>
	<div v-if="userPreferenceStore.coi.lightMode" class="px-0 " style="">
        <coi-address-edit
            :address="address"
            :countries="countries"
            :customerOrderId="customerOrderId"
            :visible="modalState_editAddress"
            ref="coiAddressEdit"
            @mutatedAddress="mutatedAddress"
        />
        <b-alert
            :show="dismissCountDown"
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
            style="position:absolute; top: 10px; left: 200px"
        >{{alertMessage}}</b-alert>
        
        <b-row>
            <b-col class="pl-0">
                <div class="container-fluid">
                    <copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
                        <b>Land: {{address.country.countryName}}</b>
                    </copy-to-clipboard-component>
                </div>
            </b-col>
        </b-row>
    </div>
    <div v-else class="px-0">
        <coi-address-edit
            :address="address"
            :countries="countries"
            :customerOrderId="customerOrderId"
            :visible="modalState_editAddress"
            ref="coiAddressEdit"
            @mutatedAddress="mutatedAddress"
        />
        <b-alert
            :show="dismissCountDown"
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
            style="position:absolute; top: 10px; left: 200px"
        >{{alertMessage}}</b-alert>

        <b-row>
            <div class="d-flex">
                <b-col class="pl-2 pr-0 mx-0 mb-1">
                    <b-button
                        class="long-button py-0 pr-0 pl-0"
                        variant="outline-primary"
                        size="sm"
                        type="button"
                        @click="editAddress()"
                    >✎</b-button>
                    <br/> <!-- fuck knows why, but this br is necessary -->
                    <b-button
                        class="long-button py-0 px-0 pt-1"
                        size="sm"
                        type="button"
                        variant="outline-primary"
                        @click="copyAddress()"
                    >🗎</b-button>
                </b-col>
            </div>
            <b-col class="pl-0">
                <div class="container-fluid" v-if="address.company">
                    <copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
                        {{address.company}}
                    </copy-to-clipboard-component>
                </div>
                <div class="container-fluid">
                    <copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
                        {{address.firstName}} {{address.lastName}}
                    </copy-to-clipboard-component>
                </div>
                <!-- notice: the filter.join op is done to remove unnecessary whitespace when concating lists if elems are missing. -->
                <div class="container-fluid">
                    <copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
                        {{[this.address.street, this.address.street2, this.address.street3 ].filter( id => id ).join(' ')}}
                    </copy-to-clipboard-component>
                </div>
                <div class="container-fluid d-flex">
                    <copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
                        {{this.address.zipCode}}
                    </copy-to-clipboard-component>
                    &#160; <!--whitespace-->
                    <copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
                        {{this.address.city}}
                    </copy-to-clipboard-component>                    
                </div>
                <div class="container-fluid">
                    <copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
                        <b>{{address.country.countryName}}</b>
                    </copy-to-clipboard-component>
                </div>
                <div class="container-fluid">
                    <b-row class="px-0 mx-0">
                        <span class="nowrap">E-Mail:&nbsp;</span>
                        <copy-to-clipboard-component
                            alertDisplayLength='1'
                            alertShowCopiedText="true"
                            :textToCopy="address.email"
                        ><!-- copy-comp -->
                            <a href="#" v-if="window.innerWidth < 1300">{{address.email.split("@")[0]}}<br>@{{address.email.split("@")[1]}}</a>
                            <a href="#" v-else>{{address.email}}</a>
                        </copy-to-clipboard-component>
                    </b-row>
                </div>
                <div class="container-fluid">
                    <b-row class="px-0 mx-0">
                        <span>Tel.:&nbsp;</span>
                        <copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
                            {{ this.address.phone }}
                        </copy-to-clipboard-component>
                    </b-row>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';

export default {
    setup(){
        const userPreferenceStore = useUserPreferenceStore();
        return {userPreferenceStore}
    },
	props: [ "address", "countries", "customerOrderId" ],
	data() {
		return {
			items: [],
            emailShortComputed: "",
            alertMessage: "",
            dismissCountDown: 0,
            modalState_editAddress: false
		};
	},
    methods: {
        mutatedAddress(hollow)
        {
            this.$emit( 'mutatedAddress', hollow ); // passthrough to root Component
        },
        countDownChanged(dismissCountDown) { this.dismissCountDown = dismissCountDown },
        copyAddress()
        {
            const el = document.createElement('textarea');

            // !!! WARNING !!! DO NOT INDENT BELOW !!!

            el.value = `${[this.address.firstName, this.address.lastName].filter( id => id).join(' ')}
${[this.address.street, this.address.street2, this.address.street3].filter(id => id).join(' ')}
${[this.address.zipCode, this.address.city ].filter( id => id ).join(' ')}
${this.address.country.countryName}`;

            // !!! WARNING !!! DO NOT INDENT ABOVE !!!

            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            this.alertMessage = `Kundenaddresse wurde in die Zwischenablage gelegt.`
            document.body.removeChild(el);
            this.$bvToast.toast( this.alertMessage, {
                title: 'Copy To Clipboard',
                autoHideDelay: 4000,
                appendToast: false
            });
        },
        editAddress()
        {
            //this.modalState_editAddress = true;
             this.$refs.coiAddressEdit.open();
        }
    }
};
</script>
<style scoped>
    .nowrap {
        white-space: nowrap ;
    }
    .long-button {
        min-width: 70% !important;
        width: 23px;
        height: 65px;
        font-size:135%;
        background:white;
    }
    .long-button:hover {
        min-width: 70% !important;
        width: 23px;
        height: 65px;
        font-size:135%;
        background:#007bff;
    }

</style>
